import {
  call,
  put,
  takeLatest,
} from 'redux-saga/effects';
import { FEATURE_FETCH } from '../actionTypes';
import { updateFeatures } from '../features';
import api from '../../utils/services';

function* getFeatures(action) {
  const data = yield call(api.features, action.carrierId);
  const features = yield data.reduce((acc, f) => {
    acc[f.type] = f.enabled;
    return acc;
  }, {});
  yield put(updateFeatures(features));
}

export default function* featureInfoSaga() {
  yield takeLatest(FEATURE_FETCH, getFeatures);
}
